import axios from './axios';

// eslint-disable-next-line import/prefer-default-export
export const loadStates = <T>() => axios.get<T>('/states');
